import { action, props } from 'ts-action';
import { SkipHistory } from '../../undo/actions/undo.actions';
import { Metric } from '../types/metric.type';

export const loaded = action(
  '[Metrics] loaded',
  props<{ metrics: Metric[] } & SkipHistory>(),
);
